import { setCookie } from '../../lib/cookies'
import CookieOptions from './CookieOptions'
import CookieOptionsView from './OptionsView'

addEventListener('DOMContentLoaded', () => {
    const cookieBar = document.querySelector('#ckie-bar')
    if (!cookieBar) return

    new CookieBar(cookieBar)
})

class CookieBar {
    
    options = { }

    constructor(element) {
        this.element = element

        // Fills this.options with keys of every option except all or denied and assigns true as value.
        for (const key of Object.keys(CookieOptions)) {
            if (!/^\d+$/.test(key)) {
                if (!key.includes('denied') && !key.includes('all')) {
                    this.options[key] = true
                }
            }
        }

        this.saveButton = this.element.querySelector('#ckies-accept')
        this.declineButton = this.element.querySelector('#ckies-denied')
        this.advancedOptions = this.element.querySelector('#advanced-options')
        this.advancedOptionsView = this.element.querySelector('div.advanced-options')

        this.saveCookieOptions = this.saveCookieOptions.bind(this)
        this.onChange = this.onChange.bind(this)
        this.onSave = this.onSave.bind(this)

        const optButton = this.element.querySelector('#advanced-options')
        const optView = this.element.querySelector('div.advanced-options')
        new CookieOptionsView(optView, optButton, this)

        this.saveButton.addEventListener('click', () => this.onSave())
        this.declineButton.addEventListener('click', () => this.saveCookieOptions(CookieOptions.denied))
    }

    onSave() {
        const values = Object.values(this.options)
        const all = values.every(v => v === true)
        const denied = values.every(v => v === false)

        if (all) {
            this.saveCookieOptions(CookieOptions.all)
        } else if (denied) {
            this.saveCookieOptions(CookieOptions.denied)
        } else {
            let selectedKeys = []
            for (const [key, value] of Object.entries(this.options)) {
                value == true && selectedKeys.push(CookieOptions[key])
            }
            this.saveCookieOptions(selectedKeys.join('-'))
        }
    }

    onChange(key, value) {
        this.options[key] = value
    }

    saveCookieOptions(cookieOptionInt) {
        this.element.parentNode.removeChild(this.element)
        setCookie('c_enabled', cookieOptionInt.toString(), 30)
    }
}